export default __webpack_public_path__ + "static/media/arrowDown.ff4514bd.svg";